// Extract only needed from fast-foundation
import {DI, Container, Registration} from '@microsoft/fast-foundation/dist/esm/di/di';
import { FoundationElement, FoundationElementRegistry } from '@microsoft/fast-foundation/dist/esm/foundation-element/foundation-element';

export { 
    DI, Container, Registration,
    FoundationElement, FoundationElementRegistry
}